import { app } from 'zapatos/schema';
import { CashflowTransactionEntry } from './types';

export const getTransactionsForSupercategories = (
    transactionEntries: CashflowTransactionEntry[],
    supercategories: app.supercategory[]
): CashflowTransactionEntry[] =>
    transactionEntries.filter(
        (transactionEntry) =>
            !transactionEntry.isHidden &&
            supercategories.includes(
                transactionEntry.category.categoryGroup.supercategory
            )
    );
